import request from '@/router/axios';
let urlPrefix = '/api/shenbao/shenbaoexpkpoint'


/**
 * 添加操作
 * @param {对象} row
 */
export const addKnowledge = data => {
    return request(`${urlPrefix}`, {
        data: data,
        method: 'post'
    })
}

/**
 * 编辑操作
 * @param {对象} row
 */
export const updateKnowledge = data => {
    return request(`${urlPrefix}`, {
        method: 'put',
        data: data
    })
}

//通过id查
export const getByID = id => {
    return request(`${urlPrefix}/${id}`)
}

//通过id删
export const removeByID = id => {
    return request(`${urlPrefix}/${id}`, null, 'delete')
}


// /shenbaoexpkpoint/query
export const getByQuery = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}